import moment from 'moment';

import { Axios } from 'common/services';
import { IExpert, IJobPost, IPageResult } from 'common/models';

export const platformAndTransactionFee = 0.11;

const getJobPosts = async (
  queryString: string
): Promise<IPageResult<IJobPost>> =>
  (await Axios.get(`/Admin/jobs?${queryString}`)).data;

const deleteJobPost = async (jobPostId: string) =>
  await Axios.delete(`/HirerJobPost/${jobPostId}/job`);

const calculateJobPostBudget = ({
  end,
  hourlyRate,
  hoursPerDay,
  start,
}: {
  end: Date | string | number;
  hourlyRate: number;
  hoursPerDay: number;
  start: Date | string | number;
}): number => {
  const days = moment(end).diff(moment(start), 'days');
  const cost = days * hoursPerDay * hourlyRate;
  const platformCharge = cost * platformAndTransactionFee;
  return cost + platformCharge;
};

const getFullTimeJobPostApplicants = async (
  jobPostId: string
): Promise<IPageResult<IExpert>> => {
  const res = await Axios.get(
    `/Admin/jobs/${jobPostId}/applicants?page=1&pageSize=200` // TO DO use proper pagination
  );
  return res.data;
};

const markCompleteFullTimeJobPost = async (jobPostId: string) =>
  Axios.put(`/Admin/jobs/${jobPostId}/complete`);

export default {
  calculateJobPostBudget,
  deleteJobPost,
  getFullTimeJobPostApplicants,
  getJobPosts,
  markCompleteFullTimeJobPost,
};
